module.exports = __webpack_public_path__ + "SP_SPT12-ToyBox-3486523af7eed0147919706dbc895431.png";